export default "__VITE_ASSET__13cd0a30__"